import tmpl from './account.phtml';
import View from 'lib/View';

import config from 'config';

export default View.extend({
	template: tmpl,

	events: {
		'click #account_delete_modal_confirm': 'onDeleteAccount'
	},

	initialize: function()
	{
		this.listenTo( this.model, 'all', this.render );
		this.listenTo( app.getStore('data'), 'all', this.render );
	},

	onDeleteAccount: function()
	{
		// Fermer la modale
		$('#account-delete-modal').modal('hide');

		// Désactiver le bouton pendant la requête
		this.$('#account_delete_modal_confirm').prop('disabled', true);

		// Envoyer la requête POST
		var deleteRequest = $.post(config.url.user + '/request-delete', {}, function(response) {
			// Afficher le message de succès
			if (response && response.message) {
				app.addMessage(response.message, 'notice');
			} else {
				app.addMessage('Votre demande de suppression a été enregistrée.', 'success');
			}

			// Rediriger vers la page de connexion
			setTimeout(function() {
				// app.signout();
			}, 2000);
		});

		deleteRequest.fail(_.bind(function(xhr) {
			// Afficher l'erreur
			var errorMessage = 'Une erreur est survenue lors de la demande de suppression.';
			if (xhr.responseJSON && xhr.responseJSON.message) {
				errorMessage = xhr.responseJSON.message;
			}
			app.addMessage(errorMessage, 'error');

			// Réactiver le bouton
			this.$('#account_delete_modal_confirm').prop('disabled', false);
		}, this));

		// Afficher le message de chargement
		app.addMessage('Demande de suppression en cours...', deleteRequest);
	},

	render: function()
	{
		this.doRender({
			user: this.model,
			data: app.getStore('data'),
			item_list: {
				name: "Nom public / Pseudo",
				fullname: "Nom complet",
				company: "Structure",
				email: "Adresse email",
				phone: "Téléphone",
				address: "Adresse",
				zip: "Code postal",
				city: "Ville"
			}
		});
	}
});


